/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{margin-top:20px;margin-bottom:-20px}.group-pending-list-item[_ngcontent-%COMP%], .group-pending-list-item[_ngcontent-%COMP%]:hover{background-color:#fff0ae}.group-pending-list-item[_ngcontent-%COMP%]:last-child{border-bottom:0}.group-pending-list-item[_ngcontent-%COMP%]   .secret__title[_ngcontent-%COMP%]{cursor:default}"];
export { styles as styles };
